import { FC, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import BrandSlice from '$store/modules/brand/brand.reducer';
import { BrandConfigurations } from '$constants/brandConfiguration';

import CustomSwitch from './components/CustomSwitch';
import './App.css';
import './tailwindCssVariables.css';
import 'react-toastify/dist/ReactToastify.css';
import { initAuth } from './store/legacy/auth';
import { useAppDispatch, useAppSelector } from './hooks';
import 'flag-icons/css/flag-icons.min.css';

const App: FC = () => {
  const dispatch = useAppDispatch();
  const { serverEmployer } = useAppSelector((state) => state.auth);
  const [, i18n] = useTranslation('global');

  // checking if user is logged in; the language only words its error messages, so a change
  // (employer and staff logins switch to English) must not reload the session.
  useEffect(() => {
    dispatch(initAuth(i18n.language));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // set the coloring and assets for the brand
  useEffect(() => {
    let brandConfig = BrandConfigurations.simera;

    const pageBrand = serverEmployer
      ? serverEmployer.brand
      : (window.CypressMock?.location?.hostname || document.location.hostname)
          .toLowerCase()
          .split('.')[0];
    switch (pageBrand) {
      // case 'localhost':
      case 'dev-jobecam':
      case 'stg-jobecam':
      case 'jobecam':
        brandConfig = BrandConfigurations.jobecam;
        break;
      case 'stg-interfell':
      case 'dev-interfell':
      case 'interfell':
        brandConfig = BrandConfigurations.interfell;
        break;
      default:
        brandConfig = BrandConfigurations.simera;
        break;
    }

    dispatch(
      BrandSlice.actions.setBrand({
        brandName: brandConfig.name,
        displayName: brandConfig.displayName,
        logoUrl: brandConfig.logoUrl,
        usdToCurrencyConverter: brandConfig.convertUsdToCurrency,
        currencyToUsdConverter: brandConfig.convertCurrencyToUSD,
        currency: brandConfig.currency,
        currencyCode: brandConfig.currencyCode,
        locale: brandConfig.locale,
      })
    );
    document.documentElement.classList.add(brandConfig.name);
  }, [dispatch, serverEmployer]);

  const pathBase = window.location.pathname.split('/')[1];

  return (
    <>
      <Router
        basename={pathBase === 'en' || pathBase === 'es' ? pathBase : '/'}
      >
        <CustomSwitch />
      </Router>
      <ToastContainer
        rtl
        bodyClassName="toast-body"
        className="toast-container"
        closeButton={false}
      />
    </>
  );
};

export default App;
